import { FunctionComponent } from 'react';
import { Separator } from '@cbridge-tools/resizable-panels';
import { StyledResizeHandle } from './StyledResizeHandle';
import { IResizeHandleProps } from './ResizeHandle.interface';

// The visible line plus its hover/active glow live in StyledResizeHandle. The Separator element
// stays 1px wide (adds no layout gap); the PanelGroup wrapper widens the actual resize hit region
// to the handle's grab area via `resizeTargetMinimumSize`, so the cursor and the draggable zone match.
export const ResizeHandle: FunctionComponent<IResizeHandleProps> = ({ direction = 'horizontal', withDivider, highlightSide }) => (
  <Separator>
    <StyledResizeHandle direction={direction} withDivider={withDivider} highlightSide={highlightSide} />
  </Separator>
);
